import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  DashboardIcon,
  UsersIcon,
  DocumentIcon,
  LockIcon,
  GroupIcon,
  BuildingIcon,
  SettingsIcon,
  LogoutIcon,
  ArrowLeftIcon
} from '../Common/Icons';

const Sidebar = ({ onToggleSidebar, onLogout }) => {
  const { isSuperAdmin } = useAuth();
  
  const menuItems = [
    {
      path: '/',
      icon: DashboardIcon,
      label: 'Dashboard',
      exact: true
    },
    {
      path: '/employees',
      icon: UsersIcon,
      label: 'Employees'
    },
    {
      path: '/documents',
      icon: DocumentIcon,
      label: 'Documents'
    },
    {
      path: '/digilocker',
      icon: LockIcon,
      label: 'DigiLocker'
    },
    {
      path: '/users',
      icon: UsersIcon,
      label: 'Users'
    },
    {
      path: '/settings',
      icon: SettingsIcon,
      label: 'Settings'
    }
  ];

  // Only show Groups and Customers menu items for super admins
  if (isSuperAdmin) {
    menuItems.splice(4, 0, {
      path: '/groups',
      icon: GroupIcon,
      label: 'Groups'
    });
    menuItems.push({
      path: '/customers',
      icon: BuildingIcon,
      label: 'Customers'
    });
  }

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <h2 className="sidebar-title">Dashboard</h2>
        <button 
          className="sidebar-toggle" 
          onClick={onToggleSidebar}
          aria-label="Toggle sidebar"
        >
          <ArrowLeftIcon className="sidebar-icon-svg" style={{ width: '18px', height: '18px' }} />
        </button>
      </div>
      <nav className="sidebar-nav">
        <ul className="nav-list">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <li key={item.path} className="nav-item">
                <NavLink
                  to={item.path}
                  className={({ isActive }) => 
                    `nav-link ${isActive ? 'active' : ''}`
                  }
                  end={item.exact}
                >
                  <span className="nav-icon">
                    <Icon className="sidebar-icon-svg" />
                  </span>
                  <span className="nav-text">{item.label}</span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>
      <div className="sidebar-footer">
        <button className="sidebar-logout" onClick={onLogout}>
          <span className="nav-icon">
            <LogoutIcon className="sidebar-icon-svg" />
          </span>
          <span className="nav-text">Logout</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
